export interface DetectionResult {
  direction: "lattocyr" | "cyrtolat";
  confidence: number;
}

export function detectLanguage(text: string): DetectionResult {
  if (!text.trim()) {
    return { direction: "lattocyr", confidence: 0 };
  }

  // Kirill harflari (Uzbek Cyrillic specific)
  const cyrillicChars = /[а-яёўқғҳА-ЯЁЎҚҒҲ]/g;

  // Lotin harflari (Uzbek Latin specific, yangi lotin harflari bilan)
  const latinChars = /[a-zA-ZoʻgʻshchngʻOʻGʻSHCHNGʻ'ÖöĞğŞşÇç]/g;

  // Uzbek Kirill uchun maxsus harflar
  const uzbekCyrillicSpecific = /[ўқғҳЎҚҒҲ]/g;

  // Uzbek Lotin uchun maxsus harflar
  const uzbekLatinSpecific = /[oʻgʻshchngʻ'ÖöĞğŞşÇç]/g;

  const cyrillicMatches = text.match(cyrillicChars) || [];
  const latinMatches = text.match(latinChars) || [];
  const uzbekCyrillicMatches = text.match(uzbekCyrillicSpecific) || [];
  const uzbekLatinMatches = text.match(uzbekLatinSpecific) || [];

  const totalChars = text.replace(/[\s\d\p{P}]/gu, "").length;

  if (totalChars === 0) {
    return { direction: "lattocyr", confidence: 0 };
  }

  const cyrillicScore =
    (cyrillicMatches.length + uzbekCyrillicMatches.length * 2) / totalChars;
  const latinScore =
    (latinMatches.length + uzbekLatinMatches.length * 2) / totalChars;

  // Agar Kirill harflari ko'p bo'lsa, Kirill → Lotin
  if (cyrillicScore > latinScore && cyrillicScore > 0.3) {
    return {
      direction: "cyrtolat",
      confidence: Math.min(cyrillicScore * 100, 95),
    };
  }

  // Agar Lotin harflari ko'p bo'lsa yoki aniqlanmasa, Lotin → Kirill
  return {
    direction: "lattocyr",
    confidence: latinScore > 0.3 ? Math.min(latinScore * 100, 95) : 50,
  };
}
